module.exports = __webpack_public_path__ + "img/dr-felicia-campbell-aligned-chiropractic.ca899556.jpg";